import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import DatePicker from '../../../../components/fields/DatePicker/DatePicker';
import InsurerDTO from '../../../../dto/InsurerDTO';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import { PROCEDURE_TYPE } from '../../../../configs';
import FileInput from '../../../../components/fields/FileInput/FileInput';
import CustomSelectInputWithHelper from '../../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadInsuranceCompaniesList } from '../../../ReferenceInformation/actions';

export default function InsuranceForm(props) {
  const {
    prefix = '', labelPrefix = '', disabled = false, control, selectedProcedure = '', formMeta,
  } = props;
  const dto = new InsurerDTO();
  const attributes = dto.getAttributesByName();

  return (
    <>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={CustomSelectInputWithHelper}
          dtoObject={attributes.insurer}
          variant="material"
          loadAction={loadInsuranceCompaniesList}
          namePrefix={prefix}
          labelPrefix={labelPrefix}
          optionFormatter={item => ({ value: item.name, name: item.name })}
          disabled={disabled}
        />
      </Row>

      { [PROCEDURE_TYPE.PROCEDURE_1227_1, PROCEDURE_TYPE.PROCEDURE_1227_2, PROCEDURE_TYPE.PROCEDURE_1227_3, PROCEDURE_TYPE.PROCEDURE_1227_4, PROCEDURE_TYPE.PROCEDURE_1227_5].includes(selectedProcedure)
        ? (
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.insurance_contract_number}
              variant="material"
              namePrefix={prefix}
              labelPrefix={labelPrefix}
              disabled={disabled}
            />
          </Row>
        )
        : (
          <Row className="row-cols-2">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.insurance_contract_series}
              variant="material"
              namePrefix={prefix}
              labelPrefix={labelPrefix}
              disabled={disabled}
            />
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.insurance_contract_number}
              variant="material"
              namePrefix={prefix}
              labelPrefix={labelPrefix}
              disabled={disabled}
            />
          </Row>

        )}
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          hideTime
          changeFormat="YYYY-MM-DD"
          dtoObject={attributes.insurance_contract_effective_date}
          variant="material"
          namePrefix={prefix}
          labelPrefix={labelPrefix}
          disabled={disabled}
          withLabel
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          hideTime
          changeFormat="YYYY-MM-DD"
          dtoObject={attributes.insurance_contract_expiration_date}
          variant="material"
          namePrefix={prefix}
          labelPrefix={labelPrefix}
          disabled={disabled}
          withLabel
        />
        {/* <FieldDTOWithCol */}
        {/*  control={control} */}
        {/*  formMeta={formMeta} */}
        {/*  type="text" */}
        {/*  component={FileInput} */}
        {/*  dtoObject={attributes.osgop_files} */}
        {/*  variant="material" */}
        {/*  multiple */}
        {/* /> */}
      </Row>
    </>
  );
}
